module.exports = "label,\nbtn-md,\na {\n    color: rgb(31, 112, 191)\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/recherche-simple/recherche-simple.component.css
// module id = ./src/app/recherche-simple/recherche-simple.component.css
// module chunks = main